<template>
  <div id="app" class="app__main">
    <!-- Displays the spinner on top of the whole application -->
    <div v-if="globals.spinnerVisible" class="loading"></div>

    <!-- Sidebar and Header - dynamically shown for Audi -->
    <AppSidebar v-if="showSidebar"
                :lang="lang"
                @set-title="currentPageTitle = $event"
                 />
    <AppHeaderAlternative v-if="showSidebar"
                          :title="currentPageTitle"
                          :lang="lang"
                          :languageList="languageList"
                          @toggle-mobile-menu="toggleMobileMenu"
                          @set-title="currentPageTitle = $event"
                          @show-language-dialog="openSelectLanguageDialog()"
                          @user-logout="userLogout()"
                          :class="sidebarClass" />

    <!-- Navbar - Switch between different components that are part of the software: clientlist, locationlist, loginform -->
    <div v-else class="navbar" id="app-navbar"  :class="sidebarClass" >
      <div class="container-fluid" style="padding-left: 0px;">
        <ul class="nav navbar-nav">
          <li v-bind:class="{ active: !$route.name }">
            <a v-if="feature.isAudiTarget" style="padding: 18px">
              <img
                src="/static/audi_loop_logo.png"
                height="18"
              />
            </a>
            <a v-else style="padding: 10px">
              <img src="/static/msm_loop_logo.png" height="40" />
            </a>
          </li>
        </ul>
        <ul class="nav navbar-nav">
          <!-- Add components here -->
          <li
            v-if="
              globals.isAccessAllowed('LoopOp_Clients_ReadAll') &&
              !globals.currentUserInfo.IsAudiUser
            "
            v-bind:class="{ active: $route.name === 'ClientManagement' }"
          >
            <router-link to="/clientmanagement">{{ lang.A0000 }}</router-link>
          </li>
          <!-- v-if="globals.currentUserInfo.IsAudiUser" -->
          <li
            v-if="
              globals.isAudiUser ||
              globals.isLeadAgencyUser ||
              globals.isAdminUser
            "
            v-bind:class="{ active: $route.name === 'configoverview' }"
          >
            <router-link to="/configoverview">{{ lang.W00066 }}</router-link>
          </li>
          <li
            v-if="globals.isAccessAllowed('LoopOp_Locations_ReadAll')"
            v-bind:class="{ active: $route.name === 'LocationManagement' }"
          >
            <router-link to="/locationmanagement">{{ lang.A0001 }}</router-link>
          </li>
          <li
            v-if="globals.isAccessAllowed('LoopOp_SecurityUsers_ReadAll')"
            v-bind:class="{ active: $route.name === 'UserManagement' }"
          >
            <router-link to="/usermanagement">{{ lang.A0010 }}</router-link>
          </li>
          <li
            v-if="globals.isAccessAllowed('LoopOp_Projects_ReadAll')"
            v-bind:class="{ active: $route.name === 'ProjectManagement' }"
          >
            <router-link to="/projectmanagement">{{ lang.A0011 }}</router-link>
          </li>
          <li
            v-if="
              globals.isAccessAllowed('LoopOp_Agencies_ReadAll') &&
              !globals.isLocalAgencyUser
            "
            v-bind:class="{ active: $route.name === 'AgencyManagement' }"
          >
            <router-link to="/agencymanagement">{{ lang.A0012 }}</router-link>
          </li>
          <li
            v-if="globals.isAccessAllowed('LoopOp_Surveys_ReadAll')"
            v-bind:class="{ active: $route.name === 'SurveyManagement' }"
          >
            <router-link to="/surveymanagement">{{ lang.A0013 }}</router-link>
          </li>
          <li
            v-if="
              globals.isAccessAllowed('LoopOp_SurveyInstances_ReadAll') &&
              globals.currentUserRole < 3
            "
            v-bind:class="{ active: $route.name === 'CheckManagement' }"
          >
            <router-link to="/checkmanagement">{{ lang.A0014 }}</router-link>
          </li>
          <li
            v-if="globals.isAccessAllowed('LoopOp_KPIs_ReadAll')"
            v-bind:class="{ active: $route.name === 'KPIManagement' }"
          >
            <router-link to="/kpimanagement">{{ lang.A0016 }}</router-link>
          </li>
          <li
            v-bind:class="{ active: $route.name === 'ShopperManagement' }"
            v-if="
              feature.isEnabled('shoppermanagement') &&
              globals.isAccessAllowed('LoopOp_Shopper_ReadAll') &&
              !(
                feature.isAudiTarget &&
                (globals.isLeadAgencyUser || globals.isAudiUser)
              )
            "
          >
            <router-link to="/shoppermanagement">{{ lang.A0023 }}</router-link>
          </li>
          <li
            v-bind:class="{ active: $route.name === 'Recruiting' }"
            v-if="
              feature.isEnabled('recruiting') &&
              globals.isAccessAllowed('LoopOp_Recruiting_ReadAll')
            "
          >
            <router-link to="/recruiting">{{ lang.A0029 }}</router-link>
          </li>
          <li
            v-bind:class="{ active: $route.name === 'ShopperApproval' }"
            v-if="
              feature.isEnabled('shopperApproval') && globals.currentUserInfo
            "
          >
            <router-link to="/shopperapproval">{{ lang.A0032 }}</router-link>
          </li>
          <li
            
            v-bind:class="{ active: $route.name === 'StatusManagement' }"
          >
            <router-link to="/statusmanagement">{{ lang.A0034 }}</router-link>
          </li>
        </ul>
        <ul v-if="userLoginState" class="nav navbar-nav navbar-right">
          <li>
            <a
              role="button"
              style="max-height: 60px"
              @click="openSelectLanguageDialog()"
            >
              <i class="material-icons md-24">public</i>
              {{ languageList[globals.selectedLanguage] }}
            </a>
          </li>
          <!-- User menu - only displayed of user is logged in -->
          <li class="dropdown">
            <a
              href="bootstrap-elements.html"
              class="dropdown-toggle"
              data-toggle="dropdown"
              style="max-height: 60px"
            >
              <i class="material-icons md-24">person</i>
              {{ globals.currentUserInfo.LoginName }}
              <b class="caret"></b>
            </a>
            <ul class="dropdown-menu">
              <li v-if="feature.isEnabled('userSettings')">
                <router-link to="/settings">
                  <i class="material-icons md-24">settings</i>
                  {{ lang.A0024 }}
                </router-link>
              </li>
              <li v-if="!feature.isAudiTarget">
                <a role="button" @click="redirectToSupport()">
                  <i class="material-icons md-24">live_help</i>
                  {{ lang.A0021 }}
                </a>
              </li>
              <li>
                <a role="button" @click="userLogout()">
                  <i class="material-icons md-24">exit_to_app</i>
                  {{ lang.A0003 }}
                </a>
              </li>
              <!-- <li>
                <a role="button">{{lang.A0004}}</a>
              </li>-->
            </ul>
          </li>
        </ul>
      </div>
    </div>


    <div class="app__router-view" :class="sidebarClass">
      <!-- Render components that are registered to the router only if user is logged in -->
      <router-view
        :key="$route.fullPath"
        v-if="isAccessTokenAvailable"
      ></router-view>
    </div>

    <!-- This modal is for choosing the language of the application -->
    <div
      class="modal fade"
      id="selectLanguageDialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal title -->
            <h4 class="modal-title">
              <b>{{ lang.A0006 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <p>
                <b>{{ lang.A0007 }}</b>
              </p>

              <div
                class="col-md-8 col-md-offset-2"
                style="padding-bottom: 20px"
              >
                <!-- Select for language -->
                <select
                  id="selectLanguage"
                  class="form-control language-select"
                  v-model="nextLanguage"
                >
                  <option
                    v-for="(language, isocode) in languageList"
                    :key="isocode"
                    :value="isocode"
                  >
                    {{ language }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default dialog-btn-primary"
              data-dismiss="modal"
              v-on:click="selectedLanguageDialogClosed"
            >
              {{ lang.A0009 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Confirmation Dialog -->
    <confirmation-dialog
      :dialogId="confirmationDialogId"
      :confirmationTitle="confirmationDialogData.confirmationTitle"
      :yesButtonText="confirmationDialogData.yesButtonText"
      :noButtonText="confirmationDialogData.noButtonText"
      :showDialog="showConfirmationDialog"
      :colorRed="confirmationDialogData.colorRed"
      :htmlText="confirmationDialogData.htmlText"
      @onYesConfirmation="onYesConfirmation"
      @onNoConfirmation="onNoConfirmation"
      @dialogClosed="onConfirmationDialogClosed"
      @closeDialog="onCloseConfirmationDialog"
    ></confirmation-dialog>

    <!-- Notification Dialog -->
    <notification-dialog
      :dialogId="notificationDialogId"
      :notificationTitle="notificationDialogData.notificationTitle"
      :closeButtonText="notificationDialogData.closeButtonText"
      :showDialog="showNotificationDialog"
      :colorRed="notificationDialogData.colorRed"
      :htmlText="notificationDialogData.htmlText"
      @closeDialog="onCloseNotificationDialog"
      @dialogClosed="onNotificationDialogClosed"
    ></notification-dialog>

    <upload-progress-modal
      :showDialog="showUploadProgress"
      :progress="globals.currentUploadProgress"
      @cancelUpload="globals.cancelPendingUploads()"
    ></upload-progress-modal>

    <edit-vat-rates-modal
      v-if="globals.currentUserRole < 2"
      :showModal="showEditVatRatesModal"
      @modalClosed="showEditVatRatesModal = false"
    ></edit-vat-rates-modal>

    <changelog-modal
      :showDialog="showChangelogModal"
      @closeDialog="showChangelogModal = false"
    ></changelog-modal>

    <HtmlEditorModal
      :showModal="showHtmlEditorModal"
      @modalClosed="showHtmlEditorModal = false"
    ></HtmlEditorModal>

    <ElementHistoryModal></ElementHistoryModal>

    <FeedModal></FeedModal>

    <div
      id="defaultAppFooter"
      :class="{ warning: globals.isLoggedInAsOtherUser }"
    >
      <span v-if="globals.isLoggedInAsOtherUser">
        {{ lang.A0033 }}:
        <router-link to="/settings">
          <b>{{ globals.currentUserInfo.IsLoggedInAsUser }}</b>
        </router-link>
      </span>
      <span id="footerLinkContainer">
        <a :href="`https://${mainOpHost}/imprint.html`" target="_blank">{{
          lang.A0018
        }}</a>
        <a
          :href="`https://${mainOpHost}/dataProtection.html`"
          target="_blank"
          >{{ lang.A0017 }}</a
        >
      </span>

      <a id="frontendVersionIndicator" @click="showChangelogModal = true"
        >v{{ appVersion }}</a
      >
    </div>
  </div>
</template>

<script>
// Import CSS
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@riophae/vue-treeselect/dist/vue-treeselect.min.css";
import "bootstrap-material-design/dist/css/bootstrap-material-design.min.css";
import "bootstrap-material-design/dist/css/ripples.min.css";

// Import JavaScript
import "bootstrap-material-design/dist/js/material.min.js";
import "bootstrap-material-design/dist/js/ripples.min.js";
import * as _ from "lodash";

// Import flatpickr
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n";

// Google Maps
import gmapsInit from "./components/Tools/gmaps";

import cssVars from "css-vars-ponyfill";

import { version as appVersion } from "../package.json";

// import dialogs
import ConfirmationDialog from "./components/Tools/Dialogs/ConfirmationDialog";
import NotificationDialog from "./components/Tools/Dialogs/NotificationDialog";
import ChangelogModal from "./components/Tools/Dialogs/ChangelogModal";
import UploadProgressModal from "./components/Tools/Dialogs/UploadProgressModal";
import EditVatRatesModal from "./components/Tools/Dialogs/EditVatRatesModal";
import HtmlEditorModal from "./components/Tools/Dialogs/HtmlEditorModal";
import FeedModal from "./components/Tools/Dialogs/FeedModal";
import ElementHistoryModal from "./components/Tools/Dialogs/ElementHistoryModal";

import AppSidebar from "./components/AppSidebar.vue";
import AppHeaderAlternative from "./components/AppHeaderAlternative.vue";

export default {
  name: "app",
  props: ["keycloak"],
  components: {
    ConfirmationDialog,
    NotificationDialog,
    ChangelogModal,
    UploadProgressModal,
    EditVatRatesModal,
    HtmlEditorModal,
    FeedModal,
    ElementHistoryModal,
    AppSidebar,
    AppHeaderAlternative
  },
  beforeCreate() {
    $.material.init();
    this.$store.commit("initStore");
    window.addEventListener("click", (e) => {
      this.$linkClicked = e.target.tagName.toLowerCase() === "a";
      setTimeout(() => {
        delete this.$linkClicked;
      }, 100);
    });
    window.addEventListener("beforeunload", () => {
      if (!this.$linkClicked) {
        this.globals.$appUnloading = true;
        this.$destroy();
      }
    });

    if (this.feature.isAudiTarget) {
      cssVars({
        variables: {
          "color-primary": "rgb(51, 51, 51)",
          "color-primary-rgb": "51, 51, 51",
          "color-primary-input": "rgb(51, 51, 51)",
          "color-primary-input-rgb": "51, 51, 51",
          "color-primary-input-hover": "rgb(76, 76, 76)",
          "color-primary-input-hover-rgb": "76, 76, 76",
          "active-alpha": "0.2",
        },
      });
      $("head > title").text("Audi Loop");
      $("head > link[type='image/x-icon']").attr(
        "href",
        "/static/favicon-audi.webp"
      );

      this.mainOpHost = "projects.audi-mysteryshopping.com";
    } else cssVars();

    // Makes tooltips available for all rendered components
    $(() => {
      $('[data-toggle="tooltip"]').tooltip();
    });

    // Allows textarea to expand automatically
    // Applied globally on all textareas with the "autoExpand" class
    $(document).on("input.autoExpand", "textarea.autoExpand", function () {
      if (!this.scrollHeight) return;
      let minRows = 1,
        rows;
      this.rows = minRows;

      let style = window
        .getComputedStyle(this, null)
        .getPropertyValue("font-size"); // Get font size from textarea
      let fontSize = parseFloat(style);

      if (!this.baseScrollHeight) {
        let valueBackup = this.value;
        this.value = "";
        this.baseScrollHeight = this.scrollHeight;
        this.value = valueBackup;
      }

      rows = Math.ceil(
        (this.scrollHeight - this.baseScrollHeight) / (fontSize + 6)
      ); // 6px for line spacing
      if (rows < 0) rows = 0;
      this.rows = minRows + rows;
    });

    $(document).on("show.bs.modal", ".modal", function () {
      var zIndex = 1040 + 10 * $(".modal:visible").length;
      $(this).css("z-index", zIndex);
      setTimeout(() => {
        $(".modal-backdrop")
          .not(".modal-stack")
          .css("z-index", zIndex - 1)
          .addClass("modal-stack");
      }, 0);
    });

    // Ensures that select2 and flatpickr can get input focus inside modal
    $.fn.modal.Constructor.prototype.enforceFocus = function () {};
  },
  created() {
    if (location.hash.indexOf("#/surveycode") > -1) return;

    let checkAccessToken = () => {
      this.isAccessTokenAvailable = !!this.$appService.getAccessToken();
      if (!this.isAccessTokenAvailable) {
        console.warn("No access token available");
      }
    };

    this.globals.$off("accessTokenChanged");
    this.globals.$on("accessTokenChanged", checkAccessToken);
    checkAccessToken();

    $(document)
      .ajaxStart(() => {
        this.globals.showSpinner();
      })
      .ajaxStop(() => {
        this.globals.hideSpinner();
      });

    this.$appService.initializeGlobalAjaxEvents();

    this.globals.$off("openGlobalConfirmationDialog");
    this.globals.$on(
      "openGlobalConfirmationDialog",
      (confirmationDialogData) => {
        this.confirmationDialogData = confirmationDialogData;
        this.openConfirmationDialog();
      }
    );

    this.globals.$off("openGlobalNotificationDialog");
    this.globals.$on(
      "openGlobalNotificationDialog",
      (notificationDialogData) => {
        this.notificationDialogData = notificationDialogData;
        this.openNotificationDialog();
      }
    );

    this.globals.$off("openEditVatRatesModal");
    this.globals.$on("openEditVatRatesModal", () => {
      this.showEditVatRatesModal = true;
    });

    this.globals.$off("openHtmlEditorModal");
    this.globals.$on("openHtmlEditorModal", () => {
      this.showHtmlEditorModal = true;
    });

    this.globals.$off("openGlobalUnsavedChangesDialog");
    this.globals.$on(
      "openGlobalUnsavedChangesDialog",
      (yesCallback, cancelCallback) => {
        this.globals.$off("GlobalUnsavedChangesYesConfirmation");
        if (yesCallback)
          this.globals.$once("GlobalUnsavedChangesYesConfirmation", () => {
            yesCallback();
          });
        this.globals.$off("GlobalUnsavedChangesNoConfirmation");
        if (cancelCallback)
          this.globals.$once("GlobalUnsavedChangesNoConfirmation", () => {
            cancelCallback();
          });

        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "GlobalUnsavedChanges",
          confirmationTitle: this.lang.A0025,
          colorRed: true,
          yesButtonText: this.lang.A0026,
          noButtonText: this.lang.A0027,
          htmlText: `<p><b>${this.lang.A0028}</b></p>`,
        });
      }
    );

    this.initGoogleApi();
  },
  mounted() {
    if (location.hash.indexOf("#/surveycode") > -1) return;

    // Gets executed right after rendering the component
    let userInfoCallback = () => {
      if (this.globals.currentUserInfo.IsAudiUser) {
        this.$router.beforeResolve((to, from, next) => {
          if (to.name === "ClientManagement") {
            next("/");
            return;
          }
          next();
        });
        if (this.$route.name === "ClientManagement") this.$router.push("/");
      }
      this.setInitialRoute();
      this.nextLanguage = this.globals.selectedLanguage;
    };
    this.globals.getCurrentUserInfo(userInfoCallback);

    this.getLanguageList();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    if (this.feature.isAudiTarget) {
      cssVars({
        variables: {
          "color-primary": "rgb(51, 51, 51)",
          "color-primary-rgb": "51, 51, 51",
          "color-primary-input": "rgb(51, 51, 51)",
          "color-primary-input-rgb": "51, 51, 51",
          "color-primary-input-hover": "rgb(76, 76, 76)",
          "color-primary-input-hover-rgb": "76, 76, 76",
          "active-alpha": "0.2",
        },
      });
      $("head > title").text("Audi Loop");
      $("head > link[type='image/x-icon']").attr(
        "href",
        "/static/favicon-audi.webp"
      );

      this.mainOpHost = "projects.audi-mysteryshopping.com";
    } else cssVars();
  },
  computed: {
    userLoginState() {
      return this.globals.currentUserInfo ? true : false;
    },
    showSidebar() {
      return false;
    },
    sidebarClass() {
      // Standard: bei <1024px schmal, bei Override breit
      if (window.innerWidth <= 1024) {
        return this.isSidebarExpanded ? "app-body-sidebar-expanded" : "app-body-sidebar";
      }
      return "app-body-sidebar";
    },
  },
  methods: {
    redirectToSupport() {
      if (this.feature.currentTarget === "china") {
        if (this.globals.currentUserRole < 2)
          window.open("https://help.msmloop.asia/redmine");
        else alert("Please contact your MSM Asia project manager!");
      } else {
        if (this.globals.currentUserRole == 2)
          window.open(
            "https://projects.msmloop.com/api/Download/055f8eec-c35a-4bf3-ad9c-3190839d62bc"
          );
        else window.open("http://help.msmloop.com/redmine/login");
      }
    },
    setInitialRoute() {
      if (this.$route.name && this.$route.name !== "PageNotFound") return; // Route is already selected

      if (this.globals.currentUserRole === 1) {
        this.globals.currentUserInfo.IsAudiUser
          ? this.$router.push("/locationmanagement")
          : this.$router.push("/clientmanagement");
      } else if (this.globals.currentUserRole === 2) {
        this.$router.push("/checkmanagement");
      }
    },
    // Opens the dialog to select a language
    openSelectLanguageDialog() {
      if (
        !this.globals.isAccessAllowed(
          "LoopOp_SecurityUsersLocalization_Update"
        ) ||
        !this.globals.isAccessAllowed("LoopOp_Language_Read")
      ) {
        this.globals.showErrorSnackbar("Access denied");
        return;
      }
      $("#selectLanguageDialog").modal("show");
    },

    userLogout() {
      this.$appService.logout();
    },

    async initGoogleApi() {
      try {
        await gmapsInit(this.globals.googleApiKey);
        this.globals.$emit("googleInitDone");
      } catch (error) {
        console.error(error);
      }
    },

    // Closes the language selection dialog
    closeSelectLanguageDialog() {
      $("#selectLanguageDialog").modal("hide");
    },

    // Requests a list of available languages from the server
    getLanguageList() {
      $.ajax({
        method: "GET",
        url: "api/Language",
        success: (data) => {
          // this.languageList = data;
          //TODO: Only show german and english in production
          this.languageList = {
            de: data.de,
            en: data.en,
          };
          if (["china", "dev"].indexOf(this.feature.currentTarget) > -1)
            this.languageList.zh = data.zh;
        },
        error: () => {
          console.error("Language data access failed in getLanguageList()");
        },
      });
    },

    selectedLanguageDialogClosed() {
      if (this.nextLanguage === this.globals.selectedLanguage) return;
      let param = "?LanguageCode=" + this.nextLanguage.substring(0, 2);

      $.ajax({
        method: "PUT",
        url: "api/SecurityUsers/Localization" + param,
        dataType: "text",
        success: (data) => {
          this.globals.selectedLanguage = this.nextLanguage;
          this.globals.showSuccessSnackbar(
            "Language switched to: " + this.globals.selectedLanguage
          );
        },
        error: () => {
          console.error("Error on PUT in selectedLanguageDialogClosed()");
          this.globals.showErrorSnackbar("Language update failed");
        },
      });
    },
    openConfirmationDialog() {
      this.confirmationDialogId =
        this.confirmationDialogData.initiator + "Confirmation";
      this.showConfirmationDialog = true;
    },
    onYesConfirmation() {
      this.globals.$emit(
        this.confirmationDialogData.initiator + "YesConfirmation"
      );
      this.showConfirmationDialog = false;
    },
    onNoConfirmation() {
      this.globals.$emit(
        this.confirmationDialogData.initiator + "NoConfirmation"
      );
      this.showConfirmationDialog = false;
    },
    onCloseConfirmationDialog() {
      this.globals.$emit(this.confirmationDialogData.initiator + "CloseDialog");
    },
    onConfirmationDialogClosed() {
      this.globals.$emit(
        this.confirmationDialogData.initiator + "DialogClosed"
      );
      this.showConfirmationDialog = false;
    },
    openNotificationDialog() {
      this.notificationDialogId =
        this.notificationDialogData.initiator + "Notification";
      this.showNotificationDialog = true;
    },
    onCloseNotificationDialog() {
      this.globals.$emit(this.notificationDialogData.initiator + "CloseDialog");
    },
    onNotificationDialogClosed() {
      this.globals.$emit(
        this.notificationDialogData.initiator + "DialogClosed"
      );
      this.showNotificationDialog = false;
    },

    toggleMobileMenu() {
      console.warn("Toggling mobile menu");
      this.isSidebarExpanded = !this.isSidebarExpanded;
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
    "globals.currentUploadProgress"(newValue) {
      if (newValue === 100) this.showUploadProgress = false;
      else {
        setTimeout(() => {
          if (this.globals.currentUploadProgress < 50)
            this.showUploadProgress = true;
        }, 1000);
      }
    },
  },
  data() {
    // Global data inside the component is stored here
    return {
      currentPageTitle: "Dashboard",
      appVersion: appVersion,
      mainOpHost: "projects.msmloop.com",
      isAccessTokenAvailable: false,
      isSidebarExpanded: false,
      nextLanguage: "en",
      languageList: {}, // Stores a list of all available languages
      lang: {
        A0000: "Clients",
        A0001: "Locations",
        A0002: "User",
        A0003: "Log Out",
        A0004: "Edit profile",
        A0006: "Language",
        A0007: "Select a language",
        A0009: "Accept",
        A0010: "Users",
        A0011: "Projects",
        A0012: "Partners",
        A0013: "Surveys",
        A0014: "Checks",
        A0015: "Survey View",
        A0016: "KPIs",
        A0017: "Data Protection",
        A0018: "Imprint",
        A0019: "Free Offers",
        A0020: "Survey Payment",
        A0021: "Support",
        A0023: "Shopper",
        A0024: "Settings",
        A0025: "Unsaved changes",
        A0026: "Yes",
        A0027: "Cancel",
        A0028: "There are unsaved changes that will be lost after this action. Do you want to proceed anyway?",
        A0029: "Recruiting",
        A0032: "Approval",
        A0033: "Logged in as",
        A0034: "Status",

        W00066: "Configurations",
      },
      confirmationDialogData: {},
      showConfirmationDialog: false,
      notificationDialogData: {},
      showNotificationDialog: false,
      confirmationDialogId: "confirmationDialog",
      notificationDialogId: "notificationDialog",
      showChangelogModal: false,
      showUploadProgress: false,
      showEditVatRatesModal: false,
      showHtmlEditorModal: false,
    };
  },
};
</script>

<style>
body,
html {
  height: 100%;
}

body {
  margin: 0;
  padding: 0;
}

.app__main {
  height: 100%;
}

.app__router-view {
  height: calc(100% - 60px);

  /* margin-left: 242px;   TODO:
  @media (max-width: 1024px) {
    margin-left: 64px;
  } */
}

:root {
  --color-primary: rgb(2, 54, 112);
  --color-primary-rgb: 2, 54, 112;
  --color-primary-input: rgb(2, 54, 112);
  --color-primary-input-rgb: 2, 54, 112;
  --color-primary-input-hover: rgb(3, 91, 188);
  --color-primary-input-hover-rgb: 3, 91, 188;
  --color-secondary-input: rgb(204, 204, 204);
  --color-secondary-input-rgb: 204, 204, 204;
  --color-panel-heading: rgb(229, 229, 229);
  --active-alpha: 0.1;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#defaultAppFooter {
  width: 100%;
  background-color: #999999;
  color: white;
  left: 0;
  bottom: 0;
  position: fixed;
  height: 20px;
  cursor: default;
}
#defaultAppFooter.warning {
  background-color: orange;
}
#defaultAppFooter a {
  color: white;
  text-decoration: none;
  cursor: pointer;
}
#frontendVersionIndicator {
  position: absolute;
  bottom: 0;
  right: 10px;
  font-size: 12px;
}
#footerLinkContainer {
  position: absolute;
  bottom: 0;
  left: 0;
}
#footerLinkContainer > a {
  margin-left: 10px;
}

/* Material icon sizes */
.material-icons.md-18 {
  font-size: 18px;
}

.material-icons.md-24 {
  font-size: 24px;
}

.material-icons.md-36 {
  font-size: 36px;
}

.material-icons.md-48 {
  font-size: 48px;
}

.material-icons.md-31 {
  font-size: 31px;
}

/* Navbar */
.navbar {
  background-color: var(--color-primary) !important;
  margin-bottom: 0px !important;
}
.dropdown-menu > li > a:hover {
  color: black !important;
}

/* Nav in modal */
.modal-dialog .nav {
  background-color: var(--color-primary);
}
.modal-dialog .nav > li {
  text-align: center;
  float: none;
  display: inline-block;
}
.nav > li.active {
  background-color: rgba(255, 255, 255, var(--active-alpha)) !important;
}

/* Dialog button colors */
.dialog-btn-primary {
  background-color: var(--color-primary-input) !important;
  color: white !important;
}
.dialog-btn-primary:hover,
.dialog-btn-primary:focus,
.dialog-btn-primary:active,
.dialog-btn-primary.active {
  background: var(--color-primary-input-hover) !important;
  border-color: var(--color-primary-input-hover) !important;
}

/* Pagination appearance */
.pagination-fonts {
  font-size: 15px;
}
.pagination {
  display: inline-block;
}
.pagination > li > a,
.pagination > li > span {
  border: 1px solid lightgray !important;
  color: black !important;
}
.pagination > li.active > a {
  background: var(--color-primary) !important;
  color: white !important;
}
.pagination > li.disabled > a {
  background-color: #f2f2f2 !important;
}
.pagination > li.active > a:hover {
  background: rgba(var(--color-primary-rgb), 0.8) !important;
  color: white !important;
}
.dropdown-element:hover {
  background-color: #f2f2f2 !important;
  color: black;
}
.dropdown-active {
  background-color: var(--color-primary);
  color: white !important;
}
.dropdown-menu > li > a:hover.dropdown-active {
  background-color: rgba(var(--color-primary-rgb), 0.8) !important;
  color: white !important;
}

/* Input elements color */
.material-input:focus,
.form-group.is-focused .form-control:focus,
.form-control.focus {
  background-image: linear-gradient(
      var(--color-primary-input),
      var(--color-primary-input)
    ),
    linear-gradient(var(--color-primary-input), var(--color-primary-input)) !important;
}
.form-group.is-focused label,
.form-group.is-focused label.control-label {
  color: var(--color-primary-input) !important;
}

.form-group select {
  appearance: menulist !important;
}

.modal {
  overflow: auto !important;
}

.modal-dialog .form-group {
  overflow: auto;
  margin: 0;
  padding: 0;
}
.modal-dialog .form-group.has-error {
  overflow: visible;
}
.modal-dialog .form-group.has-error + .form-group {
  clear: both;
}
.modal-dialog .form-group.is-focused .help-block {
  display: none;
}
.modal-dialog .form-group.has-error.is-focused .help-block {
  display: block;
}

/* Clearfix for floating elements */
.clearfix {
  clear: both;
}

/* Padding for panel-body */
.panel > .panel-body {
  padding: 5px 0 0 0 !important;
}
.panel-collapse > .panel-body {
  padding: 5px 0 20px 0 !important;
}

.panel.panel-default > .panel-heading,
.panel > .panel-heading {
  background: var(--color-panel-heading);
}

/* Colors for radio buttons and checkboxes*/
.radio label,
.checkbox label {
  color: black;
}
.radio input[type="radio"]:checked ~ .circle {
  border-color: var(--color-primary-input) !important;
}
.radio input[type="radio"]:checked ~ .check {
  background-color: var(--color-primary-input) !important;
}
.checkbox input[type="checkbox"]:checked + .checkbox-material .check,
.checkbox input[type="checkbox"]:checked + .checkbox-material .check:before {
  color: var(--color-primary-input) !important;
  border-color: var(--color-primary-input) !important;
}
.checkbox input[type="checkbox"]:disabled + .checkbox-material .check,
.checkbox input[type="checkbox"]:disabled ~ .text {
  opacity: 0.26;
  cursor: not-allowed;
}

/* Main table */
table {
  table-layout: fixed; /* fixed size */
  word-wrap: break-word;
}
.table {
  margin-bottom: 0px !important;
}
.table-header {
  color: #004080; /* color for table header elements */
}
.main-table thead {
  width: 100%;
}
.main-table tbody {
  height: auto;
  overflow-y: scroll;
  width: 100%;
}
.main-table thead tr {
  width: 100%;
  padding-right: 15px;
}
.main-table thead tr.table-filters > th {
  font-weight: normal;
}
.main-table tr {
  width: 100%;
}
.main-table thead,
.main-table tbody,
.main-table tr,
.main-table td,
.main-table th {
  display: inline-block;
}
.main-table tr.info {
  background-color: #d9edf7 !important;
}
.main-table tr.info:hover {
  background-color: #c4e3f3 !important;
}
.main-table tbody td,
.main-table thead > tr > th {
  float: left;
  border-bottom-width: 0 !important;
}
.main-table > tbody > tr > td,
.main-table > tbody > tr > th,
.main-table > thead > tr > td,
.main-table > thead > tr > th {
  text-align: center;
}
.main-table-scrollbar {
  height: 500px;
  overflow-y: scroll;
}
.main-table-scrollbar::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: lightgrey;
}
.main-table-scrollbar::-webkit-scrollbar {
  width: 15px;
}
.main-table-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: grey;
}
.main-table .form-group ::-moz-placeholder {
  line-height: 38px !important;
}

.autoExpand {
  line-height: 22px;
}

/* Searchbar positioning */
.form-group.searchbar {
  margin-top: 0px;
}
.form-group.searchbar .form-control {
  margin-top: 10px;
}

/* Removes padding and margin of any element */
.nopadding {
  padding: 0px !important;
  margin: 0px !important;
}

/* Filterbar properties */
.filterbar {
  margin: 0px !important;
  padding: 0px !important;
  text-align: center;
}

/* Buttons appearance */
.btn-top-bar.btn.btn-raised {
  width: 120px;
  height: 80px;
  margin: 8px 8px 0 8px;
  padding: 0px 5px;
  font-size: 12px;
  white-space: normal;
  background-color: var(--color-secondary-input);
}
.btn-top-bar.btn.btn-raised:disabled {
  background-color: white;
}
.btn-top-bar.btn.btn-raised:not(.btn-link):hover {
  background-color: #e5e5e5;
}
.btn:disabled {
  cursor: not-allowed !important;
}
.btn-top-bar.btn.btn-raised.top-btn-primary {
  background: grey;
  color: white;
}
.btn-top-bar.btn.btn-raised.top-btn-primary:not(.btn-link):hover {
  background-color: darkgrey;
}
.btn-top-bar.btn.btn-raised.top-btn-primary:disabled {
  background-color: white;
  color: rgba(0, 0, 0, 0.26);
}

#app .btn {
  text-transform: none;
}

/* Select2 styling */
.select2-dropdown {
  z-index: 1500 !important;
}

/* Cursor classes*/
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}

/* Disabled inputs */
.form-group input.form-control:disabled,
.form-group select.form-control:disabled,
.form-group textarea.form-control:disabled {
  background-color: rgb(240, 240, 240);
}

/* Text colors */
.text-black {
  color: #555 !important;
}
.text-primary {
  color: var(--color-primary-input) !important;
}
.text-red {
  color: red !important;
}
.text-green {
  color: green !important;
}
.text-orange {
  color: orange !important;
}

.text-bold {
  font-weight: bold;
}

.text-uppercase {
  text-transform: uppercase;
}

.hidden {
  display: none;
}

/* Flatpickr colors */
.flatpickr-calendar .flatpickr-month {
  background: var(--color-primary);
}
.flatpickr-weekdays {
  background: var(--color-primary);
}
span.flatpickr-weekday {
  color: white;
  background: var(--color-primary);
}
.flatpickr-day.selected,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.startRange,
.flatpickr-day.endRange {
  background: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
}
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover {
  background: rgba(var(--color-primary-rgb), 0.8) !important;
  border-color: rgba(var(--color-primary-rgb), 0.8) !important;
}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n + 1)),
.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n + 1)),
.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n + 1)) {
  box-shadow: -10px 0 0 var(--color-primary) !important;
}
.flatpickr-current-month .flatpickr-monthDropdown-months {
  background: var(--color-primary);
}
.flatpickr-current-month
  .flatpickr-monthDropdown-months
  .flatpickr-monthDropdown-month {
  background: var(--color-primary);
}
.flatpickr-calendar.arrowBottom:after {
  border-top-color: grey;
}
.flatpickr-calendar.arrowTop:after {
  border-bottom-color: var(--color-primary);
}
.flatpickr-calendar .flatpickr-prev-month,
.flatpickr-calendar .flatpickr-next-month {
  fill: white;
}
.flatpickr-calendar .flatpickr-prev-month:hover svg,
.flatpickr-calendar .flatpickr-next-month:hover svg {
  fill: grey;
}

#snackbar-container {
  position: fixed;
  left: calc(50% - 200px);
  width: 400px;
  text-align: center;
  bottom: 0;
  z-index: 99999;
  font-weight: bold;
}
#snackbar-container > .snackbar-success {
  background: green;
}
#snackbar-container > .snackbar-error {
  background: red;
}

/* Google places autocomplete */
.pac-container {
  z-index: 1500;
}
.pac-container::after,
.pac-container .pac-icon {
  display: none;
}

/* Tooltip styling */
.tooltip > .tooltip-inner {
  font-size: 14px;
  text-align: left;
  max-width: 600px;
  padding: 10px;
}

#GlobalUnsavedChangesConfirmation .modal-header button.close {
  display: none;
}

/*
  This displays a spinner as overlay of the whole application.
  It can be used inside all rendered components to signalize
  that the application is waiting for some data that is computed
  in the backend.
*/
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 9999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}
.loading:not(:required):after {
  content: "";
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 1500ms infinite linear;
  -moz-animation: spinner 1500ms infinite linear;
  -ms-animation: spinner 1500ms infinite linear;
  -o-animation: spinner 1500ms infinite linear;
  animation: spinner 1500ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */
@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.vue-treeselect--open {
  z-index: 3;
}

@media (max-width: 1000px) {
  #app {
    font-size: 20px;
  }
  .form-group label.control-label {
    font-size: 16px !important;
  }
  .form-control {
    font-size: 20px !important;
  }
  .btn {
    font-size: 18px !important;
  }
  .btn-top-bar.btn.btn-raised {
    width: auto;
    min-width: 120px;
  }
  #snackbar-container {
    left: calc(50% - 300px);
    width: 600px;
  }
  #snackbar-container > .snackbar {
    font-size: 22px;
  }
}


.app-body-sidebar {
   /*margin-left: 242px; */ /* TODO: Platz für die Sidebar schaffen */
  margin-top: unset;
  @media (max-width: 1024px) {
    margin-left: 64px !important;
  }
}
.app-body-sidebar-expanded {
  margin-left: 242px !important;
}
@media (max-width: 1024px) {
  .app-body-sidebar {
    margin-left: 64px !important;
  }
  .app-body-sidebar-expanded {
    margin-left: 242px !important;
  }
}

select:disabled {
  cursor: not-allowed;
}
input:disabled {
  cursor: not-allowed;
}
button:disabled {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// App.vue?1ab5386c